import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import VueFlatPickr from "vue-flatpickr-component";
import { German } from "flatpickr/dist/l10n/de";

interface Props {
    name: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DatePickerComponent',
  props: {
    name: {}
  },
  setup(__props: any) {

const props = __props;

const config = {
    locale: German,
    dateFormat: "d.m.Y",
    altInput: true,
    altFormat: "d.m.Y",
    time_24hr: true,
    disable: [
        function (date: { getDay: () => number }) {
            // return true to disable
            return date.getDay() === 0 || date.getDay() === 6;
        },
    ],
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFlatPickr), {
    class: "flatpickr",
    name: _ctx.name,
    config: config
  }, null, 8, ["name"]))
}
}

})